// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1ICvU","inputWrap":"styles_inputWrap__3FoW0","input":"styles_input__3Tx4j"};